export default {
  lock: false,
  notify: function notify (...args) {
    if (this.lock) {
      return
    }
    this.lock = true
    const ColorMap = {
      'warn': 'is-warning',
      'debug': '',
      'error': 'is-danger',
      'success': 'is-success',
      'primary': 'is-primary'
    }
    const timeoutInMillis = 2000
    if (!args.length) {
      // Logger.warn('Notify called with no arguments')
      return
    }
    const [msg, level] = args

    const colorClass = level || 'success'

    // Get the snackbar DIV
    const x = document.getElementById('snackbar')
    x.style.display = 'block'

    // Add the 'show' class to DIV
    x.className = `notification show ${ColorMap[colorClass]}`
    x.innerHTML = `<b>${msg || 'Sorry, Couldn\'t find what you were looking for'}</b>`

    // After 3 seconds, remove the show class from DIV
    setTimeout(() => {
      x.className = x.className.replace('show', '')
      x.style.display = 'none'
      this.lock = false
    }, timeoutInMillis)
  },
  startLoader: function () {
    const loaderSymbol = document.getElementById('pageLoader')
    loaderSymbol.className = 'loader show'
  },
  stopLoader: function () {
    const stopLoaderSymbol = document.getElementById('pageLoader')
    stopLoaderSymbol.className = stopLoaderSymbol.className.replace('show', '')
  }
}
